import React from 'react';
import PropTypes from 'prop-types';
import style from './CountBar.style';

const CountBarGroup = ({ children }) => {
  const [total, setTotal] = React.useState();

  React.useEffect(() => {
    let newTotal = 0;
    React.Children.forEach(children, (element) => {
      if (element.props && element.props.count > newTotal) {
        newTotal = element.props.count;
      }
    });
    setTotal(newTotal);
  }, [children]);

  return (
    <div
      style={{ visibility: total === undefined ? 'hidden' : 'visible' }}
      css={[style.countBarWrapper]}
    >
      {React.Children.map(children, (child) =>
        React.cloneElement(child, {
          total,
        })
      )}
    </div>
  );
};

CountBarGroup.propTypes = {
  children: PropTypes.node.isRequired,
};

CountBarGroup.displayName = 'CountBarGroup';

export default CountBarGroup;
